export class TabsData {
  value = "";
  title = "";
  isRoute = false;
  constructor(fields?: Partial<TabsData>) {
    Object.assign(this, fields);
  }
}
